import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'


const styles = theme => ({
  listItem: {
    padding: `${theme.spacing.unit}px 0`,
  },
  total: {
    fontWeight: '700',
  },
  title: {
    marginTop: theme.spacing.unit * 2,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paper: {
    // marginTop: theme.spacing.unit * 3,
    textAlign: 'center',
    width: '100%',
    height: '100%',
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      // marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 2,
    },
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  button: {
    // margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    width:'100%',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(37,106,167)',
    borderColor: 'rgb(37,106,167)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },

  buttonBack: {
   
    textTransform: 'none',
    fontSize: 16,
    padding: '3px 6px',
    color: '#203b60',
    width:'100%',
    backgroundColor: '#f2f2f2',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    
  },
  companyData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '100%',
  },
  commonMargin:{
    marginTop:theme.spacing.unit *4,
    marginBottom:theme.spacing.unit*8
  }
});

class Review extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.confirmTransaction = this.confirmTransaction.bind(this)

  }

  componentDidMount() {
    console.log("Montado review")
    window.scrollTo(0, 0)
    console.log("History State en el review")
    console.log(this.props.history.location.state)
  }

  confirmTransaction() {

    console.log("data")
    console.log(this.props.data)
    var body_req = JSON.stringify({
      token: this.props.data.token || "",
      period:this.props.data.period,
      company:this.props.data.form.company,
      name:this.props.data.form.name,
      email:this.props.data.form.email,
      address_line1:this.props.data.form.address_line1,
      address_zip:this.props.data.form.address_zip,
      address_city:this.props.data.form.address_city,
      
      address_country:this.props.data.form.address_country.id,
      
      services:{
        selected_apps:this.props.data.selected_apps.map(function(app){return parseInt(app.id)}),
        users:parseInt(this.props.data.users),
        support:parseInt(this.props.data.selected_support),
        pack:parseInt(this.props.data.selected_pack)
            },
      // data: this.props.form,
      // amount: this.props.amount,
      // services: this.props.services,
      // period: this.props.period

    })
    console.log("Args en confirmTransaction")
    // console.log(body_req)
    console.log(body_req)

    return fetch("/api/kalenis_web/confirm_transaction", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: body_req

    })
      .then((response) => {

        return response.json();
      }).then((json) => {

        alert("transacción finalizada")

      })
  }


  render() {
    const { classes } = this.props;
    const data = this.props.history.location.state.data;
    return (

      <React.Fragment>
        <CssBaseline />

        <main className={classes.layout}>

          <Grid container spacing={32}>

            <Grid item xs={12} sm={4}>
              <Paper className={classes.paper}>
                {/* <div className="pricing-title"> Resumen de Servicios</div> */}
                <div className="table-responsive">
                  <div className="pricing-title">Resumen</div>
                  <table style={{ fontSize: "14px" }} className='price-grid-table'>
                    <tbody>
                      <tr>
                        <td className="td-support-content">Servicios Regulares <sup>(1)</sup></td>
                        <td style={{ textAlign: 'right' }}>$ {this.props.getTotalMonth()}  USD</td>

                      </tr>
                      <tr>
                        <td className="td-support-content">{data.selected_pack_data.id === 99 ? "" : "Implementación:"} {data.selected_pack_data.name}  {data.selected_pack_data.new !== 0 ? <sup>(2)</sup> : ""}</td>
                        <td style={{ textAlign: 'right' }}>$ {data.selected_pack_data.new} USD</td>

                      </tr>

                      <tr>
                        <td className="td-support-content">Sub-Total</td>
                        <td style={{ textAlign: 'right' }}>$ {this.props.getTotalMonth() + data.selected_pack_data.new} USD</td>

                      </tr>
                      <tr>
                        <td className="td-support-content"> Impuestos</td>
                        <td style={{ textAlign: 'right' }}>$ {0.00} USD</td>

                      </tr>

                      <tr>
                        <td><strong>Total</strong></td>
                        <td style={{ textAlign: 'right' }}><strong>$ {this.props.getTotalMonth() + data.selected_pack_data.new + this.props.getTaxes()} USD </strong></td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Paper className={classes.paper}>

                <div className={classes.companyData}>
                  <div className="pricing-title">Su Empresa</div>
                  <div className="td-support-content">{data.form.company}</div>
                  <div className="td-support-content">{data.form.address_line1}</div>
                  <div className="td-support-content">{data.form.address_city}, {data.form.address_zip}</div>
                  <div className="td-support-content">{data.form.address_country.name}</div>
                  <div className="td-support-content">{data.form.email}</div>

                </div>

              </Paper>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Paper className={classes.paper}>


                {data.form.payment_method === 'transfer' &&
                  <React.Fragment>
                    <div className="pricing-title"> Medio de Pago</div>
                    <div style={{ marginTop: '10px' }}>

                      <div>Transferencia Bancaria</div>
                      <div className="td-support-content">Al concluir el proceso, recibirá por correo electrónico la información para realizar la transferencia. El servicio será habilitado 24hs luego de la acreditación</div>
                    </div>
                  </React.Fragment>
                }

                {data.form.payment_method === 'credit' &&
                  <React.Fragment>

                    <div className={classes.companyData}>
                      <div className="pricing-title"> Medio de Pago</div>
                      <div className="td-support-content">{data.token.card.brand}</div>
                      <div className="td-support-content">Titular: {data.token.card.name}</div>
                      <div className="td-support-content">Últimos Dígitos: {data.token.card.last4}</div>
                      <div className="td-support-content">Vencimiento: {data.token.card.exp_month}/{data.token.card.exp_year.toString().substring(2)}</div>
                      <div className="td-support-content">Cargo Total: <strong>$ {this.props.getTotalMonth() + data.selected_pack_data.new + this.props.getTaxes()} USD </strong></div>


                    </div>
                  </React.Fragment>
                }


              </Paper>
            </Grid>


          </Grid>

          <Grid className={classes.commonMargin} direction='row' alignItems='flex-end' justify='flex-end' container spacing="8">
                <Grid item xs={12} sm={3}>
                  <Button onClick={this.props.back} variant="contained" className={classes.buttonBack}>
                    <i style={{ marginRight: "8px" }} className="fa fa-1x fa-chevron-left"></i>
                    Volver
                  </Button>
                </Grid>

                <Grid  item xs={12} sm={3}>

                  <Button  onClick={this.confirmTransaction} variant="contained" className={classes.button}>
                    Confirmar Compra
                    <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
                  </Button>

                </Grid>
            </Grid>


          {/* <div className={classes.buttons}>

            <Button onClick={this.confirmTransaction} variant="contained" className={classes.button}>
              Confirmar
        <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
            </Button>

          </div> */}

        </main>
      </React.Fragment>

    );
  }
}


Review.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(Review));
